




















import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";

/**
 * Centered message component.
 */
@Component
export default class CenteredMessage extends Vue {
	/// Properties
	@Prop() icon!: string;
	@Prop() message!: string;
}
